import { capitalise, parseHcpFullName } from 'ts-utils';

export type ReferralClinician = {
  /** e.g. "Dr Jane Smith", title-cased like `formatHcpDetails`, as the link may not be. */
  name: string;
  clinic: string;
  /** e.g. "JS", for the badge, as we have no photo of the clinician. */
  initials: string;
};

/** The referring clinician from the referral link's `hcp` and `hcpClinic` values. */
export function referralClinician(details: { hcp: string; hcpClinic: string }): ReferralClinician {
  // Strips titles (Dr, Assoc Prof…) and credentials (MD, ", RD"…) so they don't become initials.
  const { firstName, lastName } = parseHcpFullName(details.hcp.trim());
  const surname = lastName?.split(/\s+/).pop();

  return {
    name: capitalise(details.hcp.trim().toLowerCase()),
    clinic: capitalise(details.hcpClinic.trim().toLowerCase()),
    initials: [firstName, surname].map((part) => part?.charAt(0).toUpperCase() ?? '').join(''),
  };
}
